module.exports = __webpack_public_path__ + "img/lamps.72e437af.png";